<div class="confirm-container">
  <span mat-dialog-title>Status Sequence Subscription</span>
  <div mat-dialog-content>
    <div>Are you sure you want to unsubscribe from the {{dealInfo.sequence}} status sequence?</div>

    @if (dealInfo) {
      <ul>
        <li>
          <b>Deal: </b>{{dealInfo.deal}}
        </li>
        <li>
          <b>Status Sequence: </b>{{dealInfo.sequence}}
        </li>
        <li>
          <b>Current Status: </b>{{dealInfo.status ? dealInfo.status : "None"}}
        </li>
      </ul>
    }
  </div>

  <div mat-dialog-actions style="float:right;margin:20px;">
    <button mat-button [mat-dialog-close]="{ clicked: 'Ok' }">Ok</button>
    <button mat-button [mat-dialog-close]="{ clicked: 'Cancel' }">
      Cancel
    </button>
  </div>
</div>
